(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('taskAllocation', {
                parent: 'module',
                url: '/taskAllocation',
                data: {
                    authorities: ["ROLE_TASK_ALLOCATION"]
                },
                views: {
                    'content': {
                        templateUrl: 'app/task/taskAllocation.html',
                        controller: 'TaskAllocationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('myTasks', {
                parent: 'module',
                url: '/myTasks',
                params:{page: null},
                data: {
                    authorities: ["ROLE_MY_TASK"]
                },
                views: {
                    'content': {
                        templateUrl: 'app/task/myTask.html',
                        controller: 'MyTaskController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
